export const SELECTORS_CACHE_UPDATE = 'SELECTORS_CACHE_UPDATE';
